<template>
  <BaseInnerLoading v-if="isLoading" />

  <template v-else-if="customer">
    <div class="space-y-6">
      <div>
        <CustomerInfoCard :customer="customer" />
        <div class="space-y-2">
          <div class="flex justify-center">
            <LinkToCreateEdit
              type="edit"
              :to="{
                name: 'customerEdit',
                params: {
                  customerId: customerId,
                },
              }"
            >
              Edit Customer
            </LinkToCreateEdit>
          </div>

          <RouterLink
            #default="{ href, navigate }"
            :to="{
              name: 'requestCreate',
              query: { customerId: customerId },
            }"
            custom
          >
            <ButtonPrimary
              class="w-full"
              as="a"
              :href="href"
              @click="navigate"
            >
              Request Payment
            </ButtonPrimary>
          </RouterLink>
        </div>
      </div>

      <BaseCard>
        <h2 class="mb-2 text-xl text-background-fg/87">
          Payments
        </h2>
        <PaymentRequestList :customer-id="customerId" />
      </BaseCard>
    </div>
  </template>

  <p v-else-if="isError" class="text-error">
    Error loading customer
  </p>
</template>

<script setup lang="ts">
const props = defineProps<{
  customerId: string
}>()

const {
  data: customer,
  isLoading,
  isError,
} = useCustomer(props.customerId)
</script>
